module.exports = __webpack_public_path__ + "img/go-plus-dark.3e2dce6d.png";